module.exports = __webpack_public_path__ + "fonts/Ubuntu-MediumItalic.6547990.eot";